// Agency info
export const AGENCY_CODE = "FORAVILA";
export const AGENCY_NAME = "Foravila Rentals";

// TPV config
export const TPV_BASE_LINK = "https://admin.foravilarentals.com/tpv";

// Reviews
export const MAX_REVIEW_RATING = 5;
